import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import {
  versionDiffAppointmentSelSet,
  versionDiffProductSelSet,
  versionDiffSettingSelSet,
  versionDiffTeachingSelSet,
  type VersionDiffAppointment,
  type VersionDiffProduct,
  type VersionDiffSetting,
  type VersionDiffTeachings,
  type VersionDiffWorkshop,
} from '../api/product.js';
import { Appointment } from './appointment.js';
import { Product } from './products.js';
import { Setting } from './settings.js';
import { Teaching } from './teaching.js';

@Entity()
export class ProductUpdateWithReferences extends AdornisEntity {
  static override _class = 'ProductWithReferences';

  constructor(doc: PartialEntityData<ProductUpdateWithReferences>) {
    super(doc);
  }

  @Field(type => Product)
  product!: VersionDiffProduct | VersionDiffWorkshop;

  @Field(type => [Teaching])
  teachings?: VersionDiffTeachings[];

  @Field(type => [Appointment])
  appointments?: VersionDiffAppointment[];

  @Field(type => Setting)
  setting?: Maybe<VersionDiffSetting>;
}

const ProductUpdateWithReferencesNarrSelSet = {
  product: versionDiffProductSelSet,
  teachings: versionDiffTeachingSelSet,
  appointments: versionDiffAppointmentSelSet,
  setting: versionDiffSettingSelSet,
} as const;
export type ProductUpdateWithReferencesNarrEnt = NarrowedEntity<
  ProductUpdateWithReferences,
  typeof ProductUpdateWithReferencesNarrSelSet
>;
